import m from "./module";
import { LogicFilter } from "../model/LogicFilter";

const filterDataUrl = '/logic_filter_data';
const filtersUrl = '/logic_filter_filters';

class LogicFilterService {
  constructor($injector, $q, APIService, LogService, DataSyncService) {
    "ngInject";
    this.$injector = $injector;
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
    this.DataSyncService = DataSyncService;

    this._filterData = {};
  }

  get filterData() {
    return this._filterData;
  }

  set filterData(filterData) {
    this._filterData = filterData;
  }

  create(data) {
    data = data || {};
    return new LogicFilter(data);
  }

  serialize(logicFilter) {
    return {
      id: logicFilter.id,
      events_custom_logic_groups_id: logicFilter.events_custom_logic_groups_id,
      events_custom_logic_filters_definitions_id: logicFilter.events_custom_logic_filters_definitions_id,
      events_custom_logic_filters_definitions_options_id: logicFilter.events_custom_logic_filters_definitions_options_id,
      value: logicFilter.value,
    };
  }

  getFiltersForRecapType(type, config = null) {
    return this.DataSyncService.getMultipleObjects(
      `LogicFilterFields-${type}`,
      filtersUrl,
      (data) => data,
      config
    );
  }

  getFilterData(data) {
    return this.APIService.post(filterDataUrl, data)
      .then(response => {
        if (response) {
          return response.data || {};
        }
        return {};
      });
  }
}

export default LogicFilterService;

m.service("LogicFilterService", LogicFilterService);
